import Popup from './component'

export default Popup
